export default __webpack_public_path__ + "static/media/csd_13.e5d331e4.png";